import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Planejamento de Contéudo',
    path: '/academico/planejamento_conteudo',
    name: 'planejamento_conteudo',
    component: () => import('@/views/academico/planejamentoconteudo/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.PLANEJAMENTO_CONTEUDO_LECIONADO_MENU_300300015
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Conteúdo Lecionado e Faltas',
    path: '/academico/conteudo_lecionado',
    name: 'conteudo_lecionado', //SAEWEB NEW
    component: () => import('@/views/academico/conteudolecionado/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [eTipoPermissao.CONTEUDOLECIONADONOVO_MENU_300301299],
    },
    goesToMenu: true,
  },
  {
    description: 'Conteúdo Lecionado',
    path: '/academico/conteudolecionado',
    name: 'conteudolecionado',
    component: () => import('@/views/academico/conteudolecionado/Index.vue'),
    meta: {
      isLegacy: true, //remover quando não for utilizar pelo SAEWEB antigo. Daí, vai aplicar o template por padrão
      permissions: [

      ],
    },
    goesToMenu: true,
  },
]

